import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { EXTRA_SMALL, SMALL, MEDIUM } from '../constants/sizes';
import themePropType from '../utils/themePropType';
import { interactionPropTypes } from '../utils/types';
import * as ButtonUses from './constants/ButtonUses';
import mergeThemeStyles from '../theme/mergeThemeStyles';
import { buttonTheme } from './theme/buttonTheme';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultProps = {
  use: ButtonUses.SECONDARY,
  size: MEDIUM
};
const AbstractVizExButton = styled.button.withConfig({
  displayName: "VizExButton__AbstractVizExButton",
  componentId: "sc-1b3l1er-0"
})(["", ""], ({
  theme
}) => mergeThemeStyles({
  component: 'Button',
  defaultStyles: buttonTheme,
  theme
}));
const NoSelect = styled.div.withConfig({
  displayName: "VizExButton__NoSelect",
  componentId: "sc-1b3l1er-1"
})(["user-select:none;"]);
const VizExButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(AbstractVizExButton, Object.assign({}, rest, {
    ref: ref,
    children: /*#__PURE__*/_jsx(NoSelect, {
      children: children
    })
  }));
});
VizExButton.displayName = 'VizExButton';
VizExButton.propTypes = Object.assign({
  children: PropTypes.node,
  onClick: PropTypes.func,
  size: PropTypes.oneOf([EXTRA_SMALL, SMALL, MEDIUM]),
  theme: themePropType,
  use: PropTypes.oneOf(Object.values(ButtonUses))
}, interactionPropTypes);
VizExButton.defaultProps = defaultProps;
export default VizExButton;